import DropdownOption from "../components/common/DropdownOption";
import TableColum from "./tableColumn";

export default class SegmentInfoField {
  public idSegmentInfoField: number = 0;
  public idSegmentInfo: number = 0;
  public fieldName: string = "";
  public index = 0;

  // used on ui only
  public selectedValueOption: DropdownOption<TableColum> | undefined =
    undefined;
}
